module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-notification-f4a1b0dd1a4d1a54280bfaa669be81fb.svg";